import { wrapMethodsWithLogging } from "components/helpers/ErrorHandlingHelpers";
import BaseApiRepository from "repositories/api/BaseApiRepository";
import moment from "moment";
import { AppNotificationService } from "services/AppNotificationService";

const BASE_URL = "calendar/";

class Repository {

    static async getCalendarContentAsync(rangeStart:Date, rangeEnd:Date) {
        const startStr = encodeURIComponent(moment(rangeStart).toISOString());
        const endStr = encodeURIComponent(moment(rangeEnd).toISOString());

        const response = await BaseApiRepository.getAsync(`${BASE_URL}content?rangeStart=${startStr}&rangeEnd=${endStr}`);
        return response as Response;
    }

    static async getCalendarContentTodayAsync() {
        const response = await BaseApiRepository.getAsync(`${BASE_URL}content/today`);
        return response as Response;
    }

    async fetchAppointments(): Promise<any> {
        let response: any = null;
        response = await BaseApiRepository.getAsync(`pilot/appointments`);

        if (!response.ok) {
            AppNotificationService.addWarningNotification("En feil oppstod ved henting av frav&aelig;r");
            throw new Error("Failed to fetch appointments");
        }

        const data = await response.json();
        return data;
    }

    async fetchAppointmentTypes(): Promise<any[]> {
        let response: any = null;
        response = await BaseApiRepository.getAsync("pilot/appointment/types");

        if (!response.ok) {
            AppNotificationService.addWarningNotification("En feil oppstod ved henting av frav&aelig;rs typer");
            throw new Error("Failed to fetch appointment types");
        }

        const data = await response.json();
        return data;
    }

}

wrapMethodsWithLogging(Repository);

export default Repository;
